// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I_TW","colMin":"styles_colMin__3oCli"};